import { Form } from "antd";

import { useTranslation } from "src/translations";
import { getValidationRules } from "../../../Form/components/Validations/ValidationFieldsFactory";
import { NumberInput } from "../../../Form/formComponents/Number/NumberInput";
import { HorizontalFormFieldStyle } from "../../../Form/formFieldLabelPositioning/styles/Styles";
import type { FieldMethod, FormFieldFactoryProps, ValidationRule } from "../../../Form/types/types";

export const EditableListNumberInputField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    const { t } = useTranslation();
    let numberRules = rules ? [...rules] : [];
    const fieldValidations = field.attributes?.validationRules || [];

    const hasSetPattern = fieldValidations.some((rule) => rule.name === "Pattern");
    if (!hasSetPattern) {
        const numberPatternValidation = getValidationRules([{ name: "Pattern", params: ["^[0-9]*"] } as ValidationRule]);
        numberRules = [...numberRules, ...numberPatternValidation];
    }

    const hasSetMaxLength = fieldValidations.some((rule) => rule.name === "MaxLength");
    if (!hasSetMaxLength) {
        const numberLengthValidation = getValidationRules([{ name: "MaxLength", params: [9] } as ValidationRule]);
        numberRules = [...numberRules, ...numberLengthValidation];
    }

    const hasSetMax = fieldValidations.some((rule) => rule.name === "Max");
    if (!hasSetMax) {
        const numberMaxValidation = getValidationRules([{ name: "Max", params: [999999999] } as ValidationRule]);
        numberRules = [...numberRules, ...numberMaxValidation];
    }

    const hasSetMin = fieldValidations.some((rule) => rule.name === "Min");
    if (!hasSetMin) {
        const numberMinValidation = getValidationRules([{ name: "Min", params: [0] } as ValidationRule]);
        numberRules = [...numberRules, ...numberMinValidation];
    }

    return (
        <HorizontalFormFieldStyle key={`${field.name}FormControl `}>
            <Form.Item key={`${field.name}FormItem`} name={field.name} rules={numberRules} label={t(field.translationKeys.label)}>
                <NumberInput key={field.name} name={field.name} label={field.translationKeys.label} readOnly={readOnly} />
            </Form.Item>
        </HorizontalFormFieldStyle>
    );
};
